var map = {
	"./symbol_0.png": 62912,
	"./symbol_1.png": 17737,
	"./symbol_2.png": 27026,
	"./symbol_3.png": 24891,
	"./symbol_4.png": 59588,
	"./symbol_5.png": 99533,
	"./symbol_6.png": 17910,
	"./symbol_7.png": 97887,
	"./symbol_8.png": 15624,
	"./symbol_9.png": 29841
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96339;